import React from 'react';

const VARIANT_CLASS = {
  block: 'sg-skel-block',
  line: 'sg-skel-line',
  circle: 'sg-skel-circle',
};

/**
 * Shared shimmer placeholder. Variants: block | line | circle.
 */
export function Skeleton({ variant = 'line', className = '', style, ...rest }) {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.line;
  const classes = ['sg-skel', variantClass, className].filter(Boolean).join(' ');
  return <span className={classes} style={style} aria-hidden="true" {...rest} />;
}

/**
 * Suspense fallback: a few skeleton bars in a card, not a blank page.
 */
export function PageSkeleton() {
  return (
    <div
      className="sg-page-skel"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading page"
      data-testid="page-skeleton"
    >
      <div className="card sg-page-skel-card">
        <div className="sg-page-skel-row">
          <Skeleton variant="circle" />
          <Skeleton variant="line" className="sg-skel-line--lg" />
        </div>
        <Skeleton variant="line" />
        <Skeleton variant="line" className="sg-skel-line--short" />
        <Skeleton variant="block" />
      </div>
    </div>
  );
}

export default Skeleton;
